import client from '../../services/session/apiClient';

//sorry for this, but should make ids a little more forgiving
const getId = (post) => {
  if (typeof post._id === 'string') {
    return post._id;
  } else if (post._id && post._id.$oid) {
    return post._id.$oid;
  } else {
    throw "Unable to locate post id"
  }
};

//because axios can be a pain in the cache.
const noCache = () => {
  return new Date().getTime();
};


export function getSearchFilters() {
  return client.get('/v5/socialSearchFilters').then(r => r.data);
}

export function saveSearchFilters(searchFilter) {
  return client.post('/v5/socialSearchFilters', searchFilter).then(r => r.data);
}

export function deleteSearchFilters(searchFilterId) {
  return client.delete(`/v5/socialSearchFilters/${searchFilterId}`).then(r => r.data);
}

export function postsNeedingApproval(queryParams) {
  return Promise.resolve({posts: []});
}

export const createPost = async(post) => {
  try {
    const response = await client.post('/chatter/publishing/posts', post);
    return response.data;
  } catch (e) {
    const SECEXC = "No credentials in your account have permission to publish to page.";

    let errorMsg = "We were not able to publish your post.";
    if (e.response.data && e.response.data.exception) errorMsg = e.response.data.exception;
    if (e.response.data && e.response.data.error) errorMsg = e.response.data.error;

    if (errorMsg.includes(SECEXC)) {
      throw new Error(SECEXC); // More user-friendly and standardized.
    } else {
      throw e;
    }
  }
};

export function updatePost(post) {
  //just a bandaid until can update socket and http json objects to have the same format
  return client
    .put(`/chatter/publishing/posts/${getId(post)}`, {...post, _id: getId(post)})
    .then(response => response.data);
}

export function saveNote(post, note) {
  return client.put(`/chatter/publishing/posts/${getId(post)}/notes`, note).then(response => response.data);
}

export function deletePost(post) {
  return client.delete(`/chatter/publishing/posts/${getId(post)}`);
}

export function seriesList() {
  return client.get(`/chatter/publishing/recurring?${noCache()}`).then(response => response.data);
}

export function createSeries(series) {
  return client.post('/chatter/publishing/recurring', series)
    .then(response => response.data)
    .catch((e) => {
      console.log("error saving series", e)
    });
}

export function updateSeries(series) {
  return client.put(`/chatter/publishing/recurring/${series._id}`, series)
    .then(response => response.data)
    .catch((e) => {
      console.log("updating series", e)
    });
}

export function publishingCredentials() {
  return client.get(`/chatter/publishing/credentials`).then(response => response.data);
}

export function deleteSeriesById(id) {
  return client.delete('/chatter/publishing/recurring/' + id)
    .then(response => response.data)
    .catch((e) => {
      console.error("Unable to delete series", e)
    });
}

export function getPublishingDestinations(accountId, params) {
  return client.get(`/chatter/publishing/destinations/${accountId}`, { params }).then(r => r.data);
}

export function getChatterCustomTwitterSearches(accountId) {
  return client.get(`/chatter/settings/list/customSearches/${accountId}`).then(r => r.data);
}

export function getChatterListings(accountId, provider, text, offset, limit,  onlySourceType, onlySourceAccount, listingSortOrder = 'ASC') {
  return client.get(`/chatter/settings/list/listings/${accountId}`, { params: {
      provider, text, offset, limit, onlySourceType, onlySourceAccount, sortOrder: listingSortOrder
  }}).then(r => r.data);
}

export const addExternalPublishing = async({sendibleAccountId}) => {
  try {
    const response = await client.post('/chatter/publishing/external', {sendibleAccountId});
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const removeExternalPublishing = async(recipientId) => {
  try {
    const response = await client.delete(`/chatter/publishing/external/${recipientId}`);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getHashtagMetricsList = async(hashtagMetricsParams) => {
  const response = await client.post("/social/hashtagMetrics/list", hashtagMetricsParams);
  return response.data;
};

/** Social Groups. */

export const addGroup = async (chatterListingGroup) => {
  const response = await client.post("/chatter/settings/listingGroups/add", chatterListingGroup);
  return response.data;
}

export const updateGroup = async (chatterListingGroup) => {
  const response = await client.put("/chatter/settings/listingGroups/update", chatterListingGroup);
  return response.data;
}

export const deleteGroup = async (groupId) => {
  const response = await client.delete(`/chatter/settings/listingGroups/delete/${groupId}`);
  return response.data;
}
